export default __webpack_public_path__ + "static/media/synergy-logo.48479357.png";